export var FileUploadStatus;
(function (FileUploadStatus) {
    FileUploadStatus[FileUploadStatus["Enqueued"] = 1] = "Enqueued";
    FileUploadStatus[FileUploadStatus["InProgress"] = 2] = "InProgress";
    FileUploadStatus[FileUploadStatus["Completed"] = 3] = "Completed";
    FileUploadStatus[FileUploadStatus["Failed"] = 4] = "Failed";
    FileUploadStatus[FileUploadStatus["Aborted"] = 5] = "Aborted";
})(FileUploadStatus || (FileUploadStatus = {}));
